module.exports = __webpack_public_path__ + "img/wz-5-13.7576d3cf.png";